import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { setupTheme, getColorMode } from "Libs/themes";
import { isJson } from "Libs/utils";

import type { AsyncThunkOptionType } from "Reducers/types";

export const loadTheme = createAsyncThunk<
  { name: string },
  undefined,
  AsyncThunkOptionType
>("app/theme/load_theme", async (_, { rejectWithValue }) => {
  try {
    await setupTheme();

    const colorSchemeFromCache: string = await getColorMode();

    return { name: colorSchemeFromCache };
  } catch (err) {
    if (![404, 403].includes((err as { code: number }).code)) {
      const errorMessage = isJson(err)
        ? err
        : "An error occurred while attempting to load theme.";
      logger(errorMessage, {
        action: "loadTheme"
      });
    }
    return rejectWithValue(err);
  }
});
